import React, { useEffect, useState } from 'react'
import { setGlobal, useGlobal } from 'reactn'
import { useLocation, useNavigate } from 'react-router-dom'
import ApplicationEntryComponent from 'ui/pages/med/ApplicationEntry'
import type {
  ApplicationEntryFormProps,
  EntryPlanCategory,
  partnerCompanyProps,
} from 'types/med'
import ApplicationEntryFinished from 'ui/pages/med/ApplicationEntryFinished'
import {
  getEntryPlans,
  postApplicationEntry,
  getPartnerCompanies,
} from './fetch'
import { Api401Error, ApiErrorWithMessage, NotFoundError } from '../client'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'

const ApplicationEntry: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [partnerCompanies, setPartnerCompanies] =
    useState<partnerCompanyProps[]>()
  const [entryPlans, setEntryPlans] = useState<EntryPlanCategory[]>([])
  const [closed, setClosed] = useState<boolean>(false) //NOTE:このページが要認証かどうか
  const [finished, setFinished] = useState<boolean>(false) //NOTE:データ送信が完了したかかどうか

  const [error] = useGlobal('error')

  useEffect(() => {
    // NOTE: basic認証が必要な時
    if (location.pathname === '/agency') {
      setClosed(true)
      getEntryPlans('partner')
        .then((data) => {
          setEntryPlans(data)
          return getPartnerCompanies().then(setPartnerCompanies)
        })
        .catch((e) => {
          if (e instanceof NotFoundError) {
            navigate('/404')
            return
          }
          if (e instanceof Api401Error) {
            setGlobal({ error: 'forbidden' })
            return
          }
          navigate('/error')
        })
    } else {
      getEntryPlans('direct').then(setEntryPlans)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const submitHandler = (data: ApplicationEntryFormProps) =>
    postApplicationEntry({
      closed,
      data,
    })
      .then(() => setFinished(true))
      .catch((e) => {
        if (!(e instanceof ApiErrorWithMessage)) {
          navigate('/error')
        }
        throw e
      })
  if (finished) {
    return <ApplicationEntryFinished />
  }

  if (error) {
    return <Layout header={<AppBarCommon />} />
  }

  if (closed && !partnerCompanies) return null

  return (
    <ApplicationEntryComponent
      onSubmit={submitHandler}
      partnerCompanies={partnerCompanies}
      entryPlans={entryPlans}
      defaultValues={{
        name: '',
        phone: '',
        postal_code: '',
        prefecture: '',
        city: '',
        town: '',
        street: '',
        building: '',
        is_active: true,
        admin_user: {
          last_name: '',
          first_name: '',
          last_name_kana: '',
          first_name_kana: '',
          email: '',
        },
        initial_support: {
          is_request: false,
        },
        plan_category: '',
        plan: '',
        introduced_partner: '',
        is_applied_yadoc: false,
        partner: {
          branch_name: '',
          contact_person_name: '',
          email: '',
          phone: '',
          remarks: '',
        },
      }}
    />
  )
}

export default ApplicationEntry
